import React from 'react';
import { motion } from 'framer-motion';
export function Stats() {
  const stats = [{
    value: '90+',
    label: 'Arizona Cities & Towns'
  }, {
    value: '248',
    label: 'Civic Leaders Engaged'
  }, {
    value: 'Fall 2026',
    label: 'Elections We Are Preparing For'
  }, {
    value: '100%',
    label: 'Committed to Local Decision-Making'
  }];
  return <section className="bg-pac-navy py-16 border-y-4 border-pac-gold" data-id="element-259" data-mp="29731fch1f2p0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-260" data-mp="2dym6x7tx2wsv">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-261" data-mp="2e0ywo75x2bgh">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center" data-id="element-262" data-mp="256k79bro9kjn" data-mpi={index}>
              <span className="font-serif text-4xl md:text-5xl font-bold text-white mb-2 drop-shadow-md" data-id="element-263" data-mp="e6fsqrzareti">
                {stat.value}
              </span>
              <span className="text-sm md:text-base font-bold text-pac-gold uppercase tracking-wider" data-id="element-264" data-mp="a5cg0ecjpywi">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}